/* eslint-disable jsx-a11y/alt-text,react/jsx-no-target-blank */
import React, { useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import s from './Landing.module.scss';
import phone1 from '../Resources/phone_1.png';
import phone2 from '../Resources/phone_2.png';
import appStore from '../Resources/appstore_white.svg';
import gPlay from '../Resources/googleplay_white.svg';
import Names from './Components/Names/Names';
import sr from '../Helpers/scrollReveal';

const Landing = () => {
  const { t, i18n } = useTranslation();

  console.log(i18n);

  const phone1Ref = useRef();
  const phone2Ref = useRef();

  useEffect(() => {
    sr.reveal(phone1Ref.current, {
      distance: '150px',
      duration: 1000,
      easing: 'ease-in',
      origin: 'bottom',
      viewOffset: {
        bottom: isMobile ? 200 : 400
      }
    });
    sr.reveal(phone2Ref.current, {
      distance: '150px',
      duration: 1000,
      easing: 'ease-in',
      origin: 'top',
      viewOffset: {
        bottom: isMobile ? 200 : 400
      }
    });
  }, []);

  return (
    <div className={s.container}>
      <h1>{t('referral_program')}</h1>
      <hr />
      <h2>{t('earn_with_prover')}</h2>
      <Names />
      <h2> {t('about')}</h2>
      <p className={s.about}>{t('about_text')}</p>
      <div className={s.app}>
        <h2>{t('what_do_you_need')}</h2>
        <ul className={s.list}>
          <li>
            {t('step_1')}
            <br />
            <div className={s.stores}>
              <a
                href="https://apps.apple.com/us/app/prover-swype-id/id1420462547"
                target="_blank"
              >
                <img src={appStore} />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=io.prover.swypeid"
                target="_blank"
              >
                <img src={gPlay} />
              </a>
            </div>
          </li>
          <li>{t('step_2')}</li>
          <li>
            {t('step_3')}
            <br />
            <br />
            {t('step_3_1')}
            <br />
            <br />
            {t('step_3_2')}
          </li>
        </ul>
        <div className={s.phones}>
          <img src={phone2} className={s.left} ref={phone1Ref} />
          <img src={phone1} className={s.right} ref={phone2Ref} />
        </div>
      </div>
      <h2>{t('when_bonuses')}</h2>
      <div className={s.bonuses}>
        <p>{t('you_will_get_bonuses')}</p>
        <div className={s.referralRow}>
          <div className={s.info}>
            <p>{t('builtin_purchase')}</p>
            <ul>
              <li
                dangerouslySetInnerHTML={{
                  __html: t('builtin_purchase_value_1', { value: 6 })
                }}
              />
              <li
                dangerouslySetInnerHTML={{
                  __html: t('builtin_purchase_value_2', { value: 5 })
                }}
              />
              <li
                dangerouslySetInnerHTML={{
                  __html: t('builtin_purchase_value_3', { value: 3 })
                }}
              />
            </ul>
          </div>
          <div className={s.info}>
            <p>{t('payment_inside_app')}</p>
            <ul>
              <li
                dangerouslySetInnerHTML={{
                  __html: t('builtin_purchase_value_1', { value: '0,4' })
                }}
              />
              <li
                dangerouslySetInnerHTML={{
                  __html: t('builtin_purchase_value_2', { value: '0,3' })
                }}
              />
              <li
                dangerouslySetInnerHTML={{
                  __html: t('builtin_purchase_value_3', { value: '0,2' })
                }}
              />
            </ul>
          </div>
        </div>
        <p>{t('have_referrer_conditions')}</p>
        <div className={s.referralRow}>
          <div className={s.info}>
            <p>{t('you_will_get_more_tokens')}</p>
          </div>
          <div className={s.info}>
            <p>{t('you_will_get_more_cashback')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
